var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-txt"},[_c('div',[_vm._v(" "+_vm._s(_vm.$t('welcomeTo'))+" ")]),_c('div',{staticClass:"font-weight-medium"},[_vm._v(" "+_vm._s(_vm.$config.productName)+" ")])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }